module.exports = {
      id: "women-home-usage",
      viewBox: "0 0 64.575 75.722",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#women-home",
      toString: function () {
        return this.url;
      }
    }